var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2579"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 34624807",
    d: "M8.57129 14.2866C8.57129 11.1306 11.1297 8.57227 14.2856 8.57227H23.2789C23.9449 8.57227 24.6058 8.6887 25.2317 8.9163L32.768 11.6568C33.394 11.8844 34.0548 12.0008 34.7209 12.0008H65.7142C68.8701 12.0008 71.4284 14.5592 71.4284 17.7151V65.7151C71.4284 68.871 68.8701 71.4294 65.7142 71.4294H14.2856C11.1297 71.4294 8.57129 68.871 8.57129 65.7151V14.2866Z",
    fill: "#CDAFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 34624807_2",
    d: "M0.877853 32.1959C0.413464 28.7666 3.07982 25.7148 6.54046 25.7148H73.46C76.9206 25.7148 79.5869 28.7666 79.1226 32.1959L74.4797 66.4817C74.096 69.3154 71.6767 71.4291 68.8171 71.4291H11.1833C8.32374 71.4291 5.90444 69.3154 5.52071 66.4817L0.877853 32.1959Z",
    fill: "#B98EFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.7147 34.9994C45.7147 34.605 46.0345 34.2852 46.429 34.2852H67.8576C68.252 34.2852 68.5718 34.605 68.5718 34.9994V37.1423C68.5718 37.5368 68.252 37.8566 67.8576 37.8566H46.429C46.0345 37.8566 45.7147 37.5368 45.7147 37.1423V34.9994Z",
    fill: "#F3ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1433 42.8566C57.1433 42.4621 57.4631 42.1423 57.8576 42.1423H67.8576C68.252 42.1423 68.5718 42.4621 68.5718 42.8566V44.9994C68.5718 45.3939 68.252 45.7137 67.8576 45.7137H57.8576C57.4631 45.7137 57.1433 45.3939 57.1433 44.9994V42.8566Z",
    fill: "#F3ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5004 59.2852C21.5142 59.2852 20.7147 60.0847 20.7147 61.0709C20.7147 62.0571 21.5142 62.8566 22.5004 62.8566C23.4866 62.8566 24.2861 62.0571 24.2861 61.0709C24.2861 60.0847 23.4866 59.2852 22.5004 59.2852Z",
    fill: "#F3ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1433 61.0709C27.1433 60.0847 27.9428 59.2852 28.929 59.2852C29.9152 59.2852 30.7147 60.0847 30.7147 61.0709C30.7147 62.0571 29.9152 62.8566 28.929 62.8566C27.9428 62.8566 27.1433 62.0571 27.1433 61.0709Z",
    fill: "#F3ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0718 59.2852C15.0856 59.2852 14.2861 60.0847 14.2861 61.0709C14.2861 62.0571 15.0856 62.8566 16.0718 62.8566C17.0581 62.8566 17.8576 62.0571 17.8576 61.0709C17.8576 60.0847 17.0581 59.2852 16.0718 59.2852Z",
    fill: "#F3ECFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableEmpty);
export default __webpack_public_path__ + "static/media/tableEmpty.035b274bcd477f99b647461757375390.svg";
export { ForwardRef as ReactComponent };